import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user.model';
import { Estudiante } from '../../../models/estudiante.model';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mi-perfil',
  templateUrl: './mi-perfil.component.html',
  styleUrls: ['./mi-perfil.component.css']
})
export class MiPerfilComponent implements OnInit {
  currentUser: User | null = null;
  loading = true;
  error: string | null = null;
  
  // Popup state for estudiante detail
  showDetail = false;
  selectedEstudiante: Estudiante | null = null;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Get user from auth service
    this.currentUser = this.authService.currentUserValue;

    if (!this.currentUser) {
      // If no user in memory, try to fetch from backend
      this.loadProfile();
    } else {
      this.loading = false;
    }
  }

  loadProfile(): void {
    this.loading = true;
    this.error = null;

    this.authService.getProfile().subscribe(
      user => {
        this.currentUser = user;
        this.loading = false;
      },
      error => {
        console.error('Error loading profile:', error);
        this.error = 'No se pudo cargar el perfil del usuario.';
        this.loading = false;
        
        // If unauthorized, redirect to login
        if (error.status === 401) {
          this.router.navigate(['/login']);
        }
      }
    );
  }

  refreshProfile(): void {
    this.loadProfile();
  }

  // Handle estudiante detail view
  onViewEstudianteDetail(estudiante: Estudiante): void {
    this.selectedEstudiante = estudiante;
    this.showDetail = true;
  }

  onCloseDetail(): void {
    this.showDetail = false;
    this.selectedEstudiante = null;
  }
}